import { get } from '@grubhubprod/umami-library/dist/nodash/get';
import { getConfig } from 'src/utilities/config';
import { getWindow } from 'src/utilities/window';

interface RouteDetails {
  isSelfServicePath: boolean;
  isEnterprisePath: boolean;
}

export function getRouteDetails(pathname: string): RouteDetails {
  const isSelfServiceManagementPath =
    pathname.indexOf('/corporate/management') !== -1;
  const isSelfServiceSignupPath = pathname.indexOf('/corporate/signup') !== -1;
  const isSelfServicePath =
    isSelfServiceManagementPath || isSelfServiceSignupPath;
  const isEnterprisePath = pathname.indexOf('/corporate/enterprise') !== -1;

  return {
    isSelfServicePath,
    isEnterprisePath,
  };
}

export function isSeamlessRoute(): boolean {
  const { seamlessOriginUrl } = getConfig();
  const window = getWindow();

  const urlOrigin = get(window, 'location', 'origin') || '';

  return urlOrigin.indexOf(seamlessOriginUrl) !== -1;
}
